<template>
  <div
    :class="{ active: active }"
    class="aiz-mobile-side-nav collapse-sidebar-wrap sidebar-xl d-xl-none z-1035"
  >
    <div class="overlay dark c-pointer overlay-fixed" @click="hide"></div>
    <div class="collapse-sidebar bg-white">
      <AccountOpes/>
    </div>
  </div>
</template>
<script>
import AccountOpes from "@/components/AccountOpes.vue";

export default {
  components: { AccountOpes },
  computed: {
    active() {
      return this.$store.state.common.accountPanelShow;
    },
  },
  methods: {
    hide() {
      this.$store.commit("common/SET_accountPanelShow", false);
    },
  },
  watch: {
    $route: {
      handler() {
        this.hide();
      },
    },
  },
};
</script>
